import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
// import newsimage from "../../common/images/NewsInsightsList/newsimage.png";
import clockBlack from "../../common/images/NewsInsightsList/clockBlack.svg";
// import locationBlack from "../../common/images/NewsInsightsList/locationBlack.svg";
import locationBlack from "../../common/images/NewsInsightsList/calender-black.svg";
import clockWhite from "../../common/images/NewsInsightsList/clockWhite.svg";
import locationWhite from "../../common/images/NewsInsightsList/calender-white.svg";
// import locationWhite from "../../common/images/NewsInsightsList/locationWhite.svg";
import readMoreRightArrowWhite from "../../common/images/NewsInsightsList/readMoreRightArrowWhite.svg";
import readMoreRightArrowBlack from "../../common/images/NewsInsightsList/readMoreRightArrowBlack.svg";
import ActionsButtons from "../Global/actionsButtons";
import SiteTrans from "../../components/LangConfig/siteTrans.json";
import { Link } from "gatsby";
import NewsCardsShare from "../Global/NewsCardsShare";


const NewsInsightsListingCards = (newsInsightsListingProps) => {
  // console.log("newsInsightsListingProps", newsInsightsListingProps);
  return (
    <>
      <div
        className="d-flex flex-column h-100 news-insights-cards-wrapper"
        style={{ backgroundColor: newsInsightsListingProps.cardBg }}
      >
        <div className="inthnew_logos">
        <GatsbyImage
          className="news-image"
          image={getImage(newsInsightsListingProps.featuredImage)}
          alt={"Jameel Motors"}
        />
        </div>
        <div className="news-contents-container d-flex flex-column align-items-start justify-content-between h-100">
          {/* {newsInsightsListingProps.categoryType ? (
            <div className="news-card-type font-exsm">
              {newsInsightsListingProps.categoryType}
            </div>
          ) : null} */}
          <div className="h-100">
            <Link to={newsInsightsListingProps.parmalink}>
              <p
                className="news-card-title font-smmd"
                style={{ color: newsInsightsListingProps.primaryFontColor }}
              >
                {newsInsightsListingProps.shortTitle}
              </p>
            </Link>
            <p
              className="listingCardParagraph"
              style={{ color: newsInsightsListingProps.secondaryFontColor }}
            >
              {newsInsightsListingProps.shortDescription}
            </p>
            <div className="location-date-clock-box">
              <div className="location-date-clock-wrapper d-flex flex-row justify-content-start align-items-center flex-wrap">
                <img
                  src={
                    newsInsightsListingProps.isDark
                      ? locationBlack
                      : locationWhite
                  }
                  alt=""
                  className="location-icon"
                />

                <span
                  className="location-label"
                  style={{ color: newsInsightsListingProps.secondaryFontColor }}
                >
                  {newsInsightsListingProps.publishDate}

                </span>

                <div className="news-location-divider"></div>

                <span
                  className="location-label"
                  style={{ color: newsInsightsListingProps.secondaryFontColor }}
                >
                  {newsInsightsListingProps.location}
                </span>

                <div className="news-location-divider"></div>
                <div className="d-flex">
                  <img
                    src={
                      newsInsightsListingProps.isDark ? clockBlack : clockWhite
                    }
                    alt=""
                    className="clock-icon"
                  />
                  <span
                    className="location-label"
                    style={{
                      color: newsInsightsListingProps.secondaryFontColor,
                    }}
                  >
                    {newsInsightsListingProps.readTime} {SiteTrans.mins_txt[newsInsightsListingProps.lang]}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="read-more-button-wrapper">
            <Link  to={newsInsightsListingProps.parmalink}>
              <ActionsButtons
                isDark={newsInsightsListingProps.isDark}
                label={SiteTrans.read_more_txt[newsInsightsListingProps.lang]}
                isLarge={false}
                isWatchNow={false}
                fontColor={newsInsightsListingProps.isDark ? "#000" : "#fff"}
                bgColor="transparent"
                borderColor={newsInsightsListingProps.isDark ? "#000" : "#fff"}
                actionButtonIcon={
                  newsInsightsListingProps.isDark
                    ? readMoreRightArrowBlack
                    : readMoreRightArrowWhite
                }
              />
            </Link>
            <NewsCardsShare
              title={newsInsightsListingProps.shortTitle}
              url={newsInsightsListingProps.parmalink}
              isDark={newsInsightsListingProps.isDark}
              lang={newsInsightsListingProps.lang}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsInsightsListingCards;
